<script>
    import {onMount} from "svelte";
    import {link} from "svelte-routing";
    import {GET, POST} from "../../components/communication.js";
    import {formatISODateString2FinDate} from "../../components/utils.js";

    let searchObj = {
        // Aseta defaulttina kuukauden ensimmäinen päivä
        startDate: new Date(new Date().getFullYear(), new Date().getMonth(), 1).toISOString().split("T")[0],
        // Aseta defaulttina kuukauden viimeinen päivä
        endDate: new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0).toISOString().split("T")[0]
    };

    // Päivittäiset ateriastatistiikat
    let userDailyMealStats = [];
    let goal = {};

    onMount(async function () {
        const response = GET("/F/getUserGoal");
        const data = await response;
        goal = data;

        console.log("onMount :: Haetaan käyttäjän ateriastatistiikat");
        getUserMealStats();
    });

    async function handleSubmit() {
        console.log("handleSubmit :: Haetaan ateriat");
        getUserMealStats();
    }

    async function getUserMealStats() {
        console.log("getUserMealStats :: Haetaan käyttäjän päivittäiset ateriastatistiikat");
        const response = POST("/F/userDailyMealStats", JSON.stringify(searchObj));
        const data = await response;
        userDailyMealStats = data;
    }

    function newMealDay() {
        console.log("newMealDay :: Uusi päivä");
        window.location.href = "/fin/dailyMeals/";
    }

    function calculateProteinPercentage(d) {
        return ((d.totalProtein * 4) / ((d.totalProtein * 4) + (d.totalCarbohydrate * 4) + (d.totalFat * 9)) * 100).toFixed(0) + " %";
    }

    function calculateCarbohydratePercentage(d) {
        return ((d.totalCarbohydrate * 4) / ((d.totalProtein * 4) + (d.totalCarbohydrate * 4) + (d.totalFat * 9)) * 100).toFixed(0) + " %";
    }

    function calculateFatPercentage(d) {
        return ((d.totalFat * 9) / ((d.totalProtein * 4) + (d.totalCarbohydrate * 4) + (d.totalFat * 9)) * 100).toFixed(0) + " %";
    }

</script>

<div class="page">
    <div class="container">
        <div class="row">
            <h3>Ruokapäiväkirja</h3>
        </div>

        <div class="row">
            <div class="col-3">
                <button class="btn btn-primary" on:click={() => newMealDay()}>Uusi päivä</button>
            </div>
        </div>

        {#if userDailyMealStats && userDailyMealStats.length > 0}
            <div class="row">
                <table class="table table-striped">
                    <thead>
                    <tr>
                        <th class="" scope="col">Päivä</th>
                        <th class="" scope="col">Proteiini</th>
                        <th class="" scope="col">Hiilari</th>
                        <th class="" scope="col">Rasva</th>
                        <th class="" scope="col">Kcal</th>
                    </tr>
                    </thead>
                    <tbody>
                    {#each userDailyMealStats as d}
                        <tr>
                            <td class=""><a href="/fin/dailyMeals/{d.mealDate}"
                                            use:link>{formatISODateString2FinDate(d.mealDate)}</a></td>
                            <td class="">{d.totalProtein} g / {calculateProteinPercentage(d)} / {goal.protein}</td>
                            <td class="">{d.totalCarbohydrate} / {calculateCarbohydratePercentage(d)}
                                / {goal.carbohydrate}</td>
                            <td class="">{d.totalFat} / {calculateFatPercentage(d)} / {goal.fat}</td>
                            <td class="">{d.totalEnergy} / {goal.energy}</td>
                        </tr>
                    {/each}
                    </tbody>
                </table>
            </div>
        {/if}
    </div>
</div>

